export default "__VITE_ASSET__a65b1423__"